import React from "react";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import BuildOutlinedIcon from "@mui/icons-material/BuildOutlined";
import SpeedOutlinedIcon from "@mui/icons-material/SpeedOutlined";
import DirectionsCarOutlinedIcon from "@mui/icons-material/DirectionsCarOutlined";
import ElectricBoltOutlinedIcon from "@mui/icons-material/ElectricBoltOutlined";
import HandymanOutlinedIcon from "@mui/icons-material/HandymanOutlined";
import TireRepairOutlinedIcon from "@mui/icons-material/TireRepairOutlined";
import ConstructionOutlinedIcon from "@mui/icons-material/ConstructionOutlined";
import { COLORS } from "../../constants";

const s = (extra) => ({
  position: "absolute",
  color: COLORS.themeBlack,
  pointerEvents: "none",
  userSelect: "none",
  ...extra,
});

const MechanicalBackground = () => (
  <>
    <SettingsOutlinedIcon        sx={s({ top: -60,      left: -80,    fontSize: 380, opacity: 0.07 })} />
    <SettingsOutlinedIcon        sx={s({ top: "30%",    left: "8%",   fontSize: 160, opacity: 0.05 })} />
    <SettingsOutlinedIcon        sx={s({ bottom: -70,   right: -60,   fontSize: 320, opacity: 0.07 })} />
    <SettingsOutlinedIcon        sx={s({ top: "10%",    right: "28%", fontSize: 100, opacity: 0.04 })} />
    <BuildOutlinedIcon           sx={s({ top: "18%",    right: "6%",  fontSize: 200, opacity: 0.05, transform: "rotate(-35deg)" })} />
    <BuildOutlinedIcon           sx={s({ bottom: "15%", left: "18%",  fontSize: 120, opacity: 0.04, transform: "rotate(20deg)" })} />
    <SpeedOutlinedIcon           sx={s({ top: "55%",    right: "14%", fontSize: 180, opacity: 0.05 })} />
    <SpeedOutlinedIcon           sx={s({ bottom: "8%",  left: "38%",  fontSize: 110, opacity: 0.04 })} />
    <DirectionsCarOutlinedIcon   sx={s({ top: "42%",    left: "-2%",  fontSize: 150, opacity: 0.05 })} />
    <DirectionsCarOutlinedIcon   sx={s({ top: "8%",     right: "42%", fontSize: 90,  opacity: 0.04 })} />
    <ElectricBoltOutlinedIcon    sx={s({ top: "22%",    left: "32%",  fontSize: 130, opacity: 0.04, transform: "rotate(10deg)" })} />
    <ElectricBoltOutlinedIcon    sx={s({ bottom: "20%", right: "4%",  fontSize: 100, opacity: 0.04 })} />
    <HandymanOutlinedIcon        sx={s({ top: "65%",    left: "4%",   fontSize: 140, opacity: 0.05, transform: "rotate(-15deg)" })} />
    <HandymanOutlinedIcon        sx={s({ top: "5%",     left: "20%",  fontSize: 90,  opacity: 0.04, transform: "rotate(30deg)" })} />
    <TireRepairOutlinedIcon      sx={s({ bottom: "5%",  right: "28%", fontSize: 130, opacity: 0.05 })} />
    <TireRepairOutlinedIcon      sx={s({ top: "75%",    right: "44%", fontSize: 85,  opacity: 0.04 })} />
    <ConstructionOutlinedIcon    sx={s({ top: "48%",    right: "34%", fontSize: 110, opacity: 0.04, transform: "rotate(-10deg)" })} />
    <ConstructionOutlinedIcon    sx={s({ bottom: "32%", left: "44%",  fontSize: 90,  opacity: 0.04 })} />
  </>
);

export default MechanicalBackground;
